
import proPage from './ProPageReducer';


export default proPage;
